export interface DoulaListing {
	id: string;
	user_id: string;
	status: string;
	bio: string;
	years_experience: number;
	births_attended_range: string;
	location_address: string;
	location_city: string;
	location_state: string;
	location_zip: string;
	latitude: number;
	longitude: number;
	booking_months_ahead: number;
	intro_video_url: string;
	profile_photo_url: string;
	tags: string[];
	personality_traits: string[];
	services_offered: string[];
	google_calendar_id: string;
	stripe_connect_account_id: string;
	is_verified: boolean;
	title: string;
	availability_sync_enabled: boolean;
	availability_guardrails: any;
	booking_window_months: number;
	months_available: {
		january: boolean;
		february: boolean;
		march: boolean;
		april: boolean;
		may: boolean;
		june: boolean;
		july: boolean;
		august: boolean;
		september: boolean;
		october: boolean;
		november: boolean;
		december: boolean;
	};
	// New profile preference fields
	additional_specialties?: string[];
	gender?: string;
	sexuality?: string;
	race?: string;
	religion?: string;
	style?: string[];
	doula_service_type?: string[];
	languages_spoken?: string[];
}

export interface Package {
	id: string;
	doula_listing_id: string;
	name: string;
	description: string;
	price: number;
	discount_percentage: number;
	is_active: boolean;
}

export interface Certification {
	id: string;
	doula_listing_id: string;
	name: string;
	description: string;
	issue_date: string;
	certificate_url: string;
}

export interface UserInfo {
	id: string;
	auth_user_id: string;
	email: string;
	full_name: string;
	role: string;
	avatar_url: string;
}

export interface Provider {
	name: string;
	address: string;
	place_id: string;
	types: string[];
	formatted_address: string;
	city: string;
	state: string;
	zip: string;
	latitude: number;
	longitude: number;
}

// Birth ranges constant
export const birthRanges = [
	"1-9",
	"10-19",
	"20-49",
	"50-74",
	"75-99",
	"100-199",
	"200-499",
	"500-1000",
	"1000+",
];
